import {fetchBaseQuery} from "@reduxjs/toolkit/query/react"
import {notification} from "antd";

// Настойки для API Review
export const apiQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    prepareHeaders: (headers, {getState}) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const {auth:{token}} = getState()
        const timeZone = process.env.REACT_APP_TIME_ZONE || 'GMT'
        headers.set("Authorization", `Bearer ${token}`)
        headers.set("X-Time-Zone", timeZone)
        return headers
    }
})

export const notify = (promise: Promise<any>) => {
    promise
        .then(() => notification.success({
            message: 'Успешно',
            duration: 5
        }))
        .catch(error => notification.error({
            message: `Ошибка: ${error.status}`,
            description: error.data.message,
            duration: 5
        }))
}
